import * as React from "react";

import type { AppToggleButtonProps } from "@1js/acui-button";
import { UILocation } from "@1js/acui-common";

import { RibbonToggleButton } from "../Controls";

export function getDefaultRibbonToggleButtonRenderer() {
  return (props: AppToggleButtonProps) => (
    <RibbonToggleButton
      {...props}
      location={props.location || UILocation.Ribbon}
    />
  );
}
